import BookingSuccess from './BookingSuccess';

export default BookingSuccess;
